export function Sparkline({ values }: { values: number[] }) {
  const width = 620;
  const height = 190;
  const max = Math.max(...values);
  const min = Math.min(...values);
  const range = max - min || 1;
  const points = values.map((value, index) => {
    const x = (index / (values.length - 1)) * width;
    const y = height - 18 - ((value - min) / range) * (height - 44);
    return `${x},${y}`;
  }).join(' ');
  const area = `0,${height} ${points} ${width},${height}`;
  return (
    <div className="sparkline-wrap">
      <svg viewBox={`0 0 ${width} ${height}`} role="img" aria-label="Evolucao das ultimas doze semanas">
        <defs>
          <linearGradient id="area-fill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#18a999" stopOpacity=".25" />
            <stop offset="100%" stopColor="#18a999" stopOpacity="0" />
          </linearGradient>
        </defs>
        {[40, 80, 120, 160].map((y) => <line key={y} x1="0" x2={width} y1={y} y2={y} className="chart-grid" />)}
        <polygon points={area} fill="url(#area-fill)" />
        <polyline points={points} fill="none" stroke="#168f84" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        {points.split(' ').map((point, index) => {
          const [cx, cy] = point.split(',');
          return index === values.length - 1 ? <circle key={point} cx={cx} cy={cy} r="6" fill="#fff" stroke="#168f84" strokeWidth="4" /> : null;
        })}
      </svg>
      <div className="chart-labels"><span>Sem 1</span><span>Sem 4</span><span>Sem 8</span><span>Hoje</span></div>
    </div>
  );
}

